<div class="tips" [ngClass]="variantClass">
  <button
    *ngIf="displayArrowIcon"
    app-vtmn-play-icon-button
    type="button"
    class="tips__button"
    [type]="ctaButtonType.Button"
    [size]="vtmnPlayIconButtonSize.SMALL"
    [variant]="vtmnPlayIconButtonVariant.SECONDARY"
    [attr.aria-label]="'a11y.tips.button' | translate"
    [attr.aria-expanded]="isOpen"
    [attr.aria-controls]="contentId"
    (click)="toggleOpenStatus()"
  >
    <vtmn-play-icon
      [name]="arrowIcon"
      [height]="18"
      [width]="18"
    ></vtmn-play-icon>
  </button>

  <div class="tips__title">
    <vtmn-play-icon
      *ngIf="icon"
      [name]="icon"
      class="tips__title__icon"
    ></vtmn-play-icon>

    <p class="tips__title__text">{{ title }}</p>
  </div>

  <div [id]="contentId" [hidden]="!(tips && isOpen)">
    <p *ngIf="!isTipsArray"
       class="tips__content"
       [innerHTML]="tips"
       (click)="handleClick($event)"
    ></p>

    <ul *ngIf="isTipsArray" class="tips__list">
      <li *ngFor="let tip of tips" class="tips__list-item">
        <vtmn-play-icon
          *ngIf="!skipBullet"
          class="tips__list-item__icon"
          [name]="iconType"
        ></vtmn-play-icon>
        <p [innerText]="tip"></p>
      </li>
    </ul>
  </div>
</div>
